import { Component, type ReactNode } from 'react'

interface State {
	hasError: boolean
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
	state: State = { hasError: false }

	static getDerivedStateFromError(): State {
		return { hasError: true }
	}

	componentDidCatch(error: Error) {
		console.error('[ErrorBoundary]', error)
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="min-h-screen flex items-center justify-center p-8 bg-background">
					<div className="text-center max-w-xs">
						<p className="text-sm font-medium text-foreground mb-1">Something went wrong</p>
						<p className="text-xs text-muted-foreground mb-4 leading-relaxed">The page failed to load. Reload to try again.</p>
						<button onClick={() => window.location.reload()} className="text-sm font-medium text-primary hover:underline">
							Reload page
						</button>
					</div>
				</div>
			)
		}
		return this.props.children
	}
}
